{
  "actionbar.button.add.torrent": "Add Torrent",
  "actionbar.button.remove.torrent": "Remove Torrent",
  "actionbar.button.start.torrent": "Start Torrent",
  "actionbar.button.stop.torrent": "Stop Torrent",
  "alert.settings.saved": "Successfully saved settings.",
  "alert.torrent.add": "Successfully added {countElement} {count, plural, =1 {torrent} other {torrents}}.",
  "alert.torrent.add.failed": "Failed to add {countElement} {count, plural, =1 {torrent} other {torrents}}.",
  "alert.torrent.add.sent": "{countElement} {count, plural, =1 {request} other {requests}} sent to the torrent client.",
  "alert.torrent.move": "Successfully moved {countElement} {count, plural, =1 {torrent} other {torrents}}.",
  "alert.torrent.move.failed": "Failed to move {countElement} {count, plural, =1 {torrent} other {torrents}}.",
  "alert.torrent.remove": "Successfully removed {countElement} {count, plural, =1 {torrent} other {torrents}}.",
  "alert.torrent.remove.failed": "Failed to remove {countElement} {count, plural, =1 {torrent} other {torrents}}.",
  "auth.add.user": "Add User",
  "auth.admin": "Admin",
  "auth.create.account": "Create Account",
  "auth.create.an.account": "Create an account",
  "auth.create.an.account.intro": "Welcome to Flood!",
  "auth.current.user": "Current User",
  "auth.error.password.empty": "Password cannot be empty.",
  "auth.error.username.empty": "Username cannot be empty.",
  "auth.input.clear": "Clear",
  "auth.log.in": "Log In",
  "auth.login": "Login",
  "auth.login.intro": "Log in to your account.",
  "auth.message.not.admin": "User is not Admin",
  "auth.password": "Password",
  "auth.user.accounts": "User Accounts",
  "auth.username": "Username",
  "button.add": "Add",
  "button.cancel": "Cancel",
  "button.close": "Close",
  "button.download": "Download",
  "button.new": "New",
  "button.no": "No",
  "button.ok": "OK",
  "button.retry": "Retry",
  "button.save": "Save Settings",
  "button.save.feed": "Save",
  "button.yes": "Yes",
  "connection-interruption.action.selection.config": "Update client connection settings",
  "connection-interruption.action.selection.retry": "Retry with current client connection settings",
  "connection-interruption.heading": "Cannot connect to the client",
  "connection-interruption.not.admin": "Please contact your Flood administrator if this continues.",
  "connection-interruption.verification-error": "Connection could not be verified.",
  "connection.settings.client.select": "Client",
  "connection.settings.error.empty": "Connection settings can not be empty.",
  "connection.settings.deluge": "Deluge",
  "connection.settings.deluge.host": "Host",
  "connection.settings.deluge.host.input.placeholder": "e.g. localhost",
  "connection.settings.deluge.password": "Password",
  "connection.settings.deluge.password.input.placeholder": "Password",
  "connection.settings.deluge.port": "Port",
  "connection.settings.deluge.port.input.placeholder": "e.g. 58846",
  "connection.settings.deluge.username": "Username",
  "connection.settings.deluge.username.input.placeholder": "e.g. localclient",
  "connection.settings.qbittorrent": "qBittorrent",
  "connection.settings.qbittorrent.password": "Password",
  "connection.settings.qbittorrent.password.input.placeholder": "Password",
  "connection.settings.qbittorrent.url": "URL",
  "connection.settings.qbittorrent.url.input.placeholder": "e.g. http://localhost:8080",
  "connection.settings.qbittorrent.username": "Username",
  "connection.settings.qbittorrent.username.input.placeholder": "Username",
  "connection.settings.rtorrent": "rTorrent",
  "connection.settings.rtorrent.host": "Host",
  "connection.settings.rtorrent.host.input.placeholder": "Hostname or IP",
  "connection.settings.rtorrent.port": "Port",
  "connection.settings.rtorrent.port.input.placeholder": "Port",
  "connection.settings.rtorrent.socket": "Path",
  "connection.settings.rtorrent.socket.input.placeholder": "e.g. ~/.local/share/rtorrent/rtorrent.sock",
  "connection.settings.rtorrent.type": "Connection Type",
  "connection.settings.rtorrent.type.socket": "Socket",
  "connection.settings.rtorrent.type.tcp": "TCP",
  "connection.settings.rtorrent.type.tcp.warning": "Exposing rTorrent via TCP may allow privilege escalation.",
  "connection.settings.transmission": "Transmission",
  "connection.settings.transmission.password": "Password",
  "connection.settings.transmission.password.input.placeholder": "Password",
  "connection.settings.transmission.url": "URL",
  "connection.settings.transmission.url.input.placeholder": "e.g. http://localhost:9091/transmission/rpc",
  "connection.settings.transmission.username": "Username",
  "connection.settings.transmission.username.input.placeholder": "Username",
  "dependency.loading.notifications": "Notifications",
  "dependency.loading.torrent.list": "Torrent List",
  "dependency.loading.torrent.taxonomy": "Torrent Taxonomy",
  "dependency.loading.transfer.history": "Data Transfer History",
  "dependency.loading.transfer.rate.details": "Data Transfer Rate Details",
  "feeds.applicable.feed": "Applicable Feed",
  "feeds.apply.tags": "Apply Tags",
  "feeds.browse.feeds": "Browse feeds",
  "feeds.check": "Validate the rule by trying it out. Not saved or sent.",
  "feeds.exclude": "Exclude",
  "feeds.exclude.pattern": "Exclude Pattern",
  "feeds.existing.feeds": "Existing Feeds",
  "feeds.existing.rules": "Existing Rules",
  "feeds.interval": "Interval",
  "feeds.label": "Label",
  "feeds.match": "Match",
  "feeds.match.count": "{count, plural, =1 {# match} other {# matches}}",
  "feeds.match.pattern": "Match Pattern",
  "feeds.no.feeds.available": "No feeds available.",
  "feeds.no.feeds.defined": "No feeds defined.",
  "feeds.no.items.matching": "No items matching search term.",
  "feeds.no.rules.defined": "No rules defined.",
  "feeds.regEx": "RegEx",
  "feeds.search": "Search term",
  "feeds.search.term": "Search term",
  "feeds.select.feed": "Select Feed",
  "feeds.select.interval": "Interval",
  "feeds.start.on.load": "Start on load",
  "feeds.tabs.download.rules": "Download Rules",
  "feeds.tabs.feeds": "Feeds",
  "feeds.tabs.heading": "Torrent Feeds",
  "feeds.tags": "Tags",
  "feeds.test.match": "Test Match Pattern",
  "feeds.time.day": "Days",
  "feeds.time.hr": "Hours",
  "feeds.time.min": "Minutes",
  "feeds.torrent.destination": "Torrent Destination",
  "feeds.url": "URL",
  "feeds.validation.interval.not.positive": "The interval must be a positive integer.",
  "feeds.validation.invalid.regular.expression": "Invalid regular expression.",
  "feeds.validation.must.select.feed": "You must select a feed.",
  "feeds.validation.must.specify.destination": "You must specify a destination.",
  "feeds.validation.must.specify.label": "You must specify a label.",
  "feeds.validation.must.specify.valid.feed.url": "You must specify a valid feed URL.",
  "filesystem.empty.directory": "Empty directory.",
  "filesystem.error.eacces": "Flood does not have permission to read this directory.",
  "filesystem.error.enoent": "This path does not exist. It will be created.",
  "filesystem.error.no.input": "Please enter the path.",
  "filesystem.error.unknown": "An unknown error occurred. Please try again.",
  "filesystem.fetching": "Fetching directory structure...",
  "filter.all": "All",
  "filter.status.active": "Active",
  "filter.status.checking": "Checking",
  "filter.status.completed": "Complete",
  "filter.status.downloading": "Downloading",
  "filter.status.error": "Error",
  "filter.status.inactive": "Inactive",
  "filter.status.moving": "Moving",
  "filter.status.warning": "Warning",
  "filter.status.seeding": "Seeding",
  "filter.status.stopped": "Stopped",
  "filter.status.title": "Filter by Status",
  "filter.location.title": "Filter by Location",
  "filter.tag.title": "Filter by Tag",
  "filter.tracker.title": "Filter by Tracker",
  "filter.untagged": "Untagged",
  "general.ago": "ago",
  "general.clipboard.copied": "Copied",
  "general.clipboard.copy": "Copy",
  "general.error.unknown": "An unknown error occurred",
  "general.of": "of",
  "general.to": "to",
  "locale.language.auto": "Automatic",
  "mediainfo.execError": "An error occurred while running mediainfo on the server. Check that mediainfo is installed and available in the PATH to Flood.",
  "mediainfo.fetching": "Fetching...",
  "mediainfo.heading": "Mediainfo Output",
  "notification.clear.all": "Clear All",
  "notification.feed.torrent.added.body": "{title}",
  "notification.feed.torrent.added.heading": "Feed Item Queued",
  "notification.no.notification": "No notification to display.",
  "notification.showing": "Showing",
  "notification.torrent.errored.body": "{name}",
  "notification.torrent.errored.heading": "Error Reported",
  "notification.torrent.finished.body": "{name}",
  "notification.torrent.finished.heading": "Finished Downloading",
  "priority.dont.download": "Don't Download",
  "priority.high": "High",
  "priority.low": "Low",
  "priority.normal": "Normal",
  "settings.bandwidth.slots.download.global.label": "Download Slots Global",
  "settings.bandwidth.slots.download.label": "Download Slots Per Torrent",
  "settings.bandwidth.slots.heading": "Slot Availability",
  "settings.bandwidth.slots.upload.global.label": "Upload Slots Global",
  "settings.bandwidth.slots.upload.label": "Upload Slots Per Torrent",
  "settings.bandwidth.transferrate.dropdown.preset.download.label": "Dropdown Presets: Download",
  "settings.bandwidth.transferrate.dropdown.preset.upload.label": "Dropdown Presets: Upload",
  "settings.bandwidth.transferrate.global.throttle.download": "Global Download Rate Throttle",
  "settings.bandwidth.transferrate.global.throttle.upload": "Global Upload Rate Throttle",
  "settings.bandwidth.transferrate.heading": "Transfer Rate Throttles",
  "settings.connectivity.dht.label": "Enable DHT",
  "settings.connectivity.dht.port.label": "DHT Port",
  "settings.connectivity.dpd.heading": "Decentralized Peer Discovery",
  "settings.connectivity.incoming.heading": "Incoming Connections",
  "settings.connectivity.ip.hostname.label": "Reported IP/Hostname",
  "settings.connectivity.max.http.connections": "Maximum HTTP Connections",
  "settings.connectivity.peer.exchange.label": "Enable Peer Exchange",
  "settings.connectivity.peers.desired.label": "Peers Desired",
  "settings.connectivity.peers.heading": "Peers",
  "settings.connectivity.peers.max.label": "Maximum Peers",
  "settings.connectivity.peers.min.label": "Minimum Peers",
  "settings.connectivity.peers.seeding.max.label": "Maximum Peers Seeding",
  "settings.connectivity.peers.seeding.min.label": "Minimum Peers Seeding",
  "settings.connectivity.port.open.label": "Open Port",
  "settings.connectivity.port.randomize.label": "Randomize Port",
  "settings.connectivity.port.range.label": "Port Range",
  "settings.diskusage.mount.points": "Disk Usage Mount Points",
  "settings.diskusage.show": "Show",
  "settings.resources.disk.check.hash.label": "Verify Hash on Completion",
  "settings.resources.disk.download.location.label": "Default Download Directory",
  "settings.resources.disk.heading": "Disk",
  "settings.resources.max.open.files": "Maximum Open Files",
  "settings.resources.memory.heading": "Memory",
  "settings.resources.memory.max.label": "Max Memory Usage",
  "settings.tabs.about": "About",
  "settings.tabs.authentication": "Authentication",
  "settings.tabs.bandwidth": "Bandwidth",
  "settings.tabs.connectivity": "Connectivity",
  "settings.tabs.diskusage": "Disk Usage",
  "settings.tabs.heading": "Settings",
  "settings.tabs.resources": "Resources",
  "settings.tabs.userinterface": "User Interface",
  "settings.ui.displayed.context.menu.items": "Context Menu Items",
  "settings.ui.displayed.details": "Torrent Detail Columns",
  "settings.ui.language": "Language",
  "settings.ui.misc": "Miscellaneous",
  "settings.ui.page.title.speed": "Display upload and download speed in page title",
  "settings.ui.sidebar.filter.location": "Show location filters",
  "settings.ui.sidebar.filter.tag": "Show tag filters",
  "settings.ui.sidebar.filter.tracker": "Show tracker filters",
  "settings.ui.tracker.warning.enabled": "Enable tracker warning status",
  "settings.ui.torrent.list.progress.percent": "Show percentages",
  "settings.ui.locale": "Locale",
  "settings.ui.tag.selector.mode": "Tag Selector Preference",
  "settings.ui.tag.selector.mode.multi": "Multi Selection",
  "settings.ui.tag.selector.mode.single": "Single Selection",
  "settings.ui.torrent.context.menu.items.show": "Show",
  "settings.ui.torrent.details.enabled": "Enabled",
  "settings.ui.torrent.details.tags.placement": "In the expanded view, tags work best at the end of the list.",
  "settings.ui.torrent.list": "Torrent List Display",
  "settings.ui.torrent.size": "Torrent Size",
  "settings.ui.torrent.size.condensed": "Condensed View",
  "settings.ui.torrent.size.expanded": "Expanded View",
  "sidebar.button.feeds": "Feeds",
  "sidebar.button.log.out": "Log Out",
  "sidebar.button.settings": "Settings",
  "sidebar.button.speedlimits": "Speed Limits",
  "sidebar.button.theme.dark": "Dark Theme",
  "sidebar.button.theme.light": "Light Theme",
  "sidebar.search.placeholder": "Search torrents",
  "sidebar.speedlimits.download": "DOWNLOAD",
  "sidebar.speedlimits.upload": "UPLOAD",
  "sidebar.transferdata.downloaded": "Downloaded",
  "sidebar.transferdata.uploaded": "Uploaded",
  "speed.unlimited": "Unlimited",
  "status.diskusage.free": "Free",
  "status.diskusage.title": "Disk Usage",
  "status.diskusage.total": "Total",
  "status.diskusage.used": "Used",
  "torrent.list.peers": "{connected} {of} {total}",
  "torrent.list.peers.of": "of",
  "torrents.add.button.add": "Add Torrent",
  "torrents.add.cookies.input.placeholder": "Optional cookie-name=cookie-value",
  "torrents.add.cookies.label": "Cookies",
  "torrents.add.destination.label": "Destination",
  "torrents.add.destination.placeholder": "Destination",
  "torrents.add.heading": "Add Torrents",
  "torrents.add.start.label": "Start Torrent",
  "torrents.add.tab.create.title": "Create",
  "torrents.add.tab.file.browse": "or click to browse",
  "torrents.add.tab.file.drop": "Drop some files here,",
  "torrents.add.tab.file.title": "By File",
  "torrents.add.tab.url.input.placeholder": "Torrent URL, Magnet Link, or Info Hash",
  "torrents.add.tab.url.register.magnet.handler": "Register to handle magnet links",
  "torrents.add.tab.url.title": "By URL",
  "torrents.add.tags": "Tags",
  "torrents.add.torrents.label": "Torrents",
  "torrents.create.base.name.input.placeholder": "Optional base file or directory name of the torrent",
  "torrents.create.base.name.label": "Base Name",
  "torrents.create.comment.input.placeholder": "Optional comment in torrent file",
  "torrents.create.comment.label": "Comment",
  "torrents.create.info.source.input.placeholder": "Optional source entry in infohash",
  "torrents.create.info.source.label": "Info Source",
  "torrents.create.is.private.label": "Private",
  "torrents.create.source.path.label": "Source",
  "torrents.create.tags.input.placeholder": "Tags in Flood. Not added to created torrent.",
  "torrents.create.tracker.input.placeholder": "Tracker URL",
  "torrents.create.trackers.label": "Trackers",
  "torrents.destination.base_path": "Use as Base Path",
  "torrents.destination.completed": "Completed",
  "torrents.destination.sequential": "Sequential Download",
  "torrents.details.actions.pause": "Pause",
  "torrents.details.actions.start": "Start",
  "torrents.details.actions.stop": "Stop",
  "torrents.details.details": "Details",
  "torrents.details.files": "Files",
  "torrents.details.files.download.file": "{count, plural, =1 {Download File} other {Download Files}}",
  "torrents.details.files.loading": "Loading file detail...",
  "torrents.details.general.comment": "Comment",
  "torrents.details.general.connected": "{connected} connected of {total}",
  "torrents.details.general.date.active": "Last Activity",
  "torrents.details.general.date.active.now": "Now",
  "torrents.details.general.date.added": "Added",
  "torrents.details.general.date.created": "Created",
  "torrents.details.general.date.finished": "Finished",
  "torrents.details.general.downloaded": "Downloaded",
  "torrents.details.general.free.disk.space": "Free Disk Space",
  "torrents.details.general.hash": "Hash",
  "torrents.details.general.heading.general": "General",
  "torrents.details.general.heading.torrent": "Torrent",
  "torrents.details.general.heading.tracker": "Tracker",
  "torrents.details.general.heading.transfer": "Transfer",
  "torrents.details.general.location": "Location",
  "torrents.details.general.none": "None",
  "torrents.details.general.peers": "Peers",
  "torrents.details.general.scheduler": "Scheduler",
  "torrents.details.general.scheduler.ignored": "Ignored",
  "torrents.details.general.scheduler.obeyed": "Obeyed",
  "torrents.details.general.seeds": "Seeds",
  "torrents.details.general.size": "Size",
  "torrents.details.general.tags": "Tags",
  "torrents.details.general.tracker.message": "Tracker Message",
  "torrents.details.general.type": "Type",
  "torrents.details.general.type.private": "Private",
  "torrents.details.general.type.public": "Public",
  "torrents.details.mediainfo": "Mediainfo",
  "torrents.details.peers": "Peers",
  "torrents.details.peers.no.data": "There is no peer data for this torrent.",
  "torrents.details.selected.files": "{count, plural, =1 {{countElement} selected file} other {{countElement} selected files}}",
  "torrents.details.selected.files.set.priority": "Set Priority",
  "torrents.details.trackers": "Trackers",
  "torrents.details.trackers.no.data": "There is no tracker data for this torrent.",
  "torrents.details.trackers.type": "Type",
  "torrents.generate.magnet.heading": "Generate Magnet Link",
  "torrents.generate.magnet.loading.trackers": "Loading trackers...",
  "torrents.generate.magnet.magnet": "Magnet Link",
  "torrents.generate.magnet.magnet.with.trackers": "Magnet Link with Trackers",
  "torrents.generate.magnet.private.torrent": "This is a private torrent.",
  "torrents.list.cannot.connect": "Cannot connect to the client.",
  "torrents.list.clear.filters": "Clear Filters",
  "torrents.list.context.check.hash": "Check Hash",
  "torrents.list.context.details": "Torrent Details",
  "torrents.list.context.download.contents": "Download Contents",
  "torrents.list.context.download.metainfo": "Download .torrent",
  "torrents.list.context.generate.magnet": "Generate Magnet Link",
  "torrents.list.context.initial.seeding": "Initial Seeding",
  "torrents.list.context.move": "Set Torrent Location",
  "torrents.list.context.pause": "Pause",
  "torrents.list.context.priority": "Priority",
  "torrents.list.context.reannounce": "Reannounce",
  "torrents.list.context.remove": "Remove",
  "torrents.list.context.sequential": "Sequential",
  "torrents.list.context.set.tags": "Set Tags",
  "torrents.list.context.set.trackers": "Set Trackers",
  "torrents.list.context.start": "Start",
  "torrents.list.context.stop": "Stop",
  "torrents.list.drop": "Drop files here to add them.",
  "torrents.list.no.torrents": "No torrents to display.",
  "torrents.move.button.set.location": "Set Location",
  "torrents.move.button.state.setting": "Setting...",
  "torrents.move.check_hash.label": "Check hash",
  "torrents.move.data.label": "Move data",
  "torrents.move.heading": "Set Torrent Location",
  "torrents.properties.comment": "Comment",
  "torrents.properties.date.active": "Last Activity",
  "torrents.properties.date.added": "Added",
  "torrents.properties.date.created": "Created",
  "torrents.properties.date.finished": "Finished",
  "torrents.properties.directory": "Location",
  "torrents.properties.download.speed": "Download Speed",
  "torrents.properties.download.total": "Downloaded",
  "torrents.properties.eta": "ETA",
  "torrents.properties.free.disk.space": "Free Disk Space",
  "torrents.properties.hash": "Hash",
  "torrents.properties.ignore.schedule": "Ignore Scheduler",
  "torrents.properties.is.private": "Private",
  "torrents.properties.name": "Name",
  "torrents.properties.peers": "Peers",
  "torrents.properties.percentage": "Progress",
  "torrents.properties.ratio": "Ratio",
  "torrents.properties.seeds": "Seeds",
  "torrents.properties.selected.size": "Selected Size",
  "torrents.properties.size": "File Size",
  "torrents.properties.tags": "Tags",
  "torrents.properties.tracker.message": "Tracker Message",
  "torrents.properties.trackers": "Trackers",
  "torrents.properties.upload.speed": "Upload Speed",
  "torrents.properties.upload.total": "Uploaded",
  "torrents.remove": "Remove Torrents",
  "torrents.remove.are.you.sure": "Are you sure you want to remove {count, plural, =1 {# torrent} other {# torrents}}?",
  "torrents.remove.delete.data": "Delete data",
  "torrents.remove.error.no.torrents.selected": "You haven't selected any torrents.",
  "torrents.set.tags.button.set": "Set Tags",
  "torrents.set.tags.enter.tags": "Enter tags",
  "torrents.set.tags.heading": "Set Tags",
  "torrents.set.trackers.button.set": "Set Trackers",
  "torrents.set.trackers.enter.tracker": "Enter a tracker",
  "torrents.set.trackers.heading": "Set Trackers",
  "torrents.set.trackers.loading.trackers": "Loading trackers...",
  "torrents.sort.title": "Sort By",
  "unit.size.byte": "B",
  "unit.size.gigabyte": "GB",
  "unit.size.kilobyte": "kB",
  "unit.size.megabyte": "MB",
  "unit.size.terabyte": "TB",
  "unit.speed": "{baseUnit}/s",
  "unit.time.day": "d",
  "unit.time.hour": "hr",
  "unit.time.infinity": "∞",
  "unit.time.minute": "m",
  "unit.time.second": "s",
  "unit.time.week": "wk",
  "unit.time.year": "yr"
}
